import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import I18NextHttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export default function initTranslations(base: string) {
  i18next
    .use(I18nextBrowserLanguageDetector)
    .use(I18NextHttpBackend)
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: "fr",
      backend: {
        loadPath: `${base}/locales/{{lng}}.i18n.json`,
      },
    });
}
